export const searchLinks = {
  searchResultsLink: () => '',
}

export type SearchLinks = typeof searchLinks
